/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { FC } from 'react'
import LayoutDefault from '@/components/layouts/Layout'
import SectionHeaderService from '@/components/modules/SectionHeaderService'
import TitleShadow from '@/components/modules/TitleShadow'
import Benefit from '@/components/modules/Benefit'
import ListBullet from '@/components/modules/ListBullet'
import ServiceItem from '@/components/modules/ServiceItem'
import PortfolioItem from '@/components/modules/PortfolioItem'
import WarrantyItem from '@/components/modules/WarrantyItem'
import ServiceGetInTouch from '@/components/modules/ServiceGetInTouch'
import Button from '@/components/elements/Button'
import ImgResponsive from '@/components/elements/ImgResponsive'
import Router from 'next/router'
import { FaArrowRight } from 'react-icons/fa'
import Link from 'next/link'

const ServicePage: FC = () => {
  return (
    <LayoutDefault>
      <SectionHeaderService
        bgColors='#FFAC79'
        bgImage='/images/service/Twin_Service_SME.webp'
        bgImageMd='/images/service/Twin_Service_SME.webp'
        bgImageSm='/images/service/Twin_Service_SME.webp'
        title={<>&quot;เว็บไซต์จะช่วยให้ธุรกิจของคุณประสบความสำเร็จ&quot;</>}
        description='"Website empowering your business success"'
        bgImageWidth={1214}
        bgImageHeight={534}
        btnText='Start Project'
        onClick={() => Router.push('/contact-service')}
        prologue='SME'
        colorPrologue='rgba(0,0,0,.08)'
        titleShadow='เว็บไซต์สำหรับธุรกิจ SME'
        colorTitleShadow='#000000'
        align='center'
        content={
          <>
            <p className='text-center'>
              การพัฒนาเว็บไซต์สำหรับธุรกิจ SME (SME Website Development) นั้น WordPress
              น่าจะเป็นทางเลือกที่ดีที่สุดสำหรับชั่วโมงนี้ โดยเหตุผลหลัก ๆ
              เลยก็น่าจะเป็นเรื่องของราคาที่ถูกกว่าการพัฒนาเว็บไซต์ทั่วไปมากและใช้เวลาในการสร้างไม่นาน
              ถ้าจะให้พูดถึงข้อดี - ข้อเสียของ WordPress ก็คงจะมีข้อดีมากกว่าข้อเสียแน่นอน
            </p>
            <p className='text-center'>
              การพัฒนาเว็บไซต์ด้วย WordPress ทำได้ไม่ยากนัก
              ไม่จำเป็นต้องมีความเชี่ยวชาญในการเขียนโค้ดก็สามารถทำได้ เนื่องจาก WordPress
              นั้นมีระบบจัดการเนื้อหา (CMS) และ UI Theme แบบกึ่งสำเร็จรูปมาให้เรียบร้อยแล้ว
              พร้อมทั้งมี Plug-in มากมายให้เลือกใช้เพื่อช่วยเพิ่มศักยภาพให้เว็บไซต์อีกด้วย
              แต่อย่างไรก็ตามการสร้างเว็บไซต์ด้วย WordPress
              ก็ยังต้องคำนึงถึงความสมบูรณ์แบบในการสร้างและประสิทธิภาพในการทำงานของเว็บไซต์อยู่ดี
              รวมถึงการดูแลรักษาด้วยนะ
              ดังนั้นทีมพัฒนาที่มีความเชี่ยวชาญในการดำเนินการทั้งในส่วนของการออกแบบและสร้างเว็บไซต์ที่สมบูรณ์แบบยังมีความจำเป็นมาก
              เรียกง่าย ๆ ว่า อะไรที่ลูกค้าไม่ชำนาญ ปล่อยให้มืออาชีพอย่างพวกเราทำแทนก็แล้วกันนะครับ
              อิอิ
            </p>
            <p className='text-center'>
              Twin Synergy คือทีมพัฒนาเว็บไซต์ที่มีประสบการณ์และมีความเชี่ยวชาญสูง
              เราสามารถแนะนำเทคโนโลยีและโซลูชั่นที่ดีที่สุดในการพัฒนาเว็บไซต์
              ให้เหมาะสมกับความต้องการของลูกค้า การประเมินราคาและระยะเวลาของโครงการที่แม่นยำ
              โดยเราให้ความสำคัญในการบริหารโครงการอย่างมีประสิทธิภาพและโปร่งใส
              รวมถึงมุ่งเน้นการดูแลและการให้บริการลูกค้า โดยยึดเอาความพึงพอใจของลูกค้าเป็นหลัก
            </p>
            <div className='text-center'>
              <Button
                htmlType='button'
                className='btn-neutral'
                onClick={() => Router.push('/contact-service')}
              >
                สอบถามเพิ่มเติม
              </Button>
            </div>
          </>
        }
      />
      <div className='pb-24 lg:pb-0 xl:pt-44'>
        <div className='container mx-auto space-y-8 px-4 lg:pt-44 xl:pt-0'>
          <TitleShadow
            prologue='ข้อดี - ข้อเสีย'
            colorPrologue='rgba(0,0,0,.08)'
            title={
              <>
                เรามาดูข้อดี - ข้อเสียของการพัฒนา
                <br />
                เว็บไซต์สำหรับธุรกิจ SME ด้วย WordPress กันก่อนที่จะตัดสินใจ
              </>
            }
            colorTitle='#000000'
            align='center'
          />
          <div className='grid grid-cols-1 gap-8 lg:grid-cols-2'>
            <Benefit
              className='border-none text-content-base'
              title={
                <>
                  เหมาะมากสำหรับธุรกิจ
                  <br />
                  SME หรือ Start Up
                </>
              }
              prologue='01'
              subtitle='ใช้งบประมาณในการสร้างไม่สูง'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={<>เพราะ WordPress มีให้แทบทุกอย่างแล้ว</>}
              prologue='02'
              subtitle='ใช้เวลาในการสร้างน้อย'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <div className='lg:col-span-2'>
              <ImgResponsive
                src='/images/service/middle_sevice_sme.webp'
                alt='Twin Synergy service'
                sourceImgSm='/images/service/middle_sevice_sme.webp'
                sourceImgMd='/images/service/middle_sevice_sme.webp'
                loadingLazy
                className='mx-auto'
              />
            </div>
            <Benefit
              className='border-none text-content-base'
              title={
                <>
                  และทันสมัย ให้เลือก
                  <br />
                  มากมายประหยัดเวลา
                  <br />
                  ในการดีไซน์
                </>
              }
              prologue='03'
              subtitle='มี UI Theme ที่สวย'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={
                <>
                  ที่แบ่งตามประเภท
                  <br />
                  ธุรกิจให้เลือกเยอะมาก
                </>
              }
              prologue='04'
              subtitle='ความปลอดภัย'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={
                <>
                  ที่ช่วยเพิ่มประสิทธิ
                  <br />
                  ภาพให้เว็บไซต์และ
                  <br />
                  ธุรกิจของเรา
                </>
              }
              prologue='05'
              subtitle='มีสิ่งที่เรียกว่า Plug-in'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={<>การทำ SEO มาก</>}
              prologue='06'
              subtitle='เหมาะสำหรับ'
              subTitlePosition='top'
              colorPrologue='rgba(0,0,0,.08)'
              colorTitle='#000000'
              colorSubtitle='#000000'
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
          </div>
        </div>
      </div>
      <div className='bg-author-base py-24'>
        <div className='container mx-auto space-y-8 px-4 xl:px-0'>
          <div className='grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-8'>
            <div className='wordpress-defect'>
              <h3 className='mb-16 text-4xl'>ข้อเสีย WordPress</h3>
              <div className='space-y-4 lg:pr-24'>
                <div className='qa-question'>
                  <h5 className='text-2xl font-bold'>01. ระบบบริหารจัดการเนื้อหา (CMS)</h5>
                  <p>
                    ที่มีมาให้ อาจใช้งานค่อนข้างยากนิดนึงสำหรับมือใหม่
                    <br />
                    ต้องใช้เวลาเรียนรู้
                  </p>
                </div>
                <div className='qa-question'>
                  <h5 className='text-2xl font-bold'>02. ความยืดหยุ่น</h5>
                  <p>ในการปรับแต่งน้อยหรืออาจทำไม่ได้ในบางกรณี</p>
                </div>
                <div className='qa-question'>
                  <h5 className='text-2xl font-bold'>
                    03. เว็บไซต์ WordPress มักตก เป็นเป้าของ Hacker
                  </h5>
                  <p>
                    มักมีความเสี่ยงจากการโดนโจมตี ดังนั้นการดูแลรักษา เว็บไซต์เป็นสิ่งสำคัญที่สุด
                    สำหรับเว็บไซต์ที่พัฒนา ด้วย WordPress
                  </p>
                </div>
                <div className='qa-question'>
                  <h5 className='text-2xl font-bold'>04. Plug-in ซับซ้อน หากเลือกที่ไม่เหมาะสม</h5>
                  <p>จะทำให้เว็บไซต์มีปัญหา จะเป็นต้องใช้ เวลาและประสบการณ์ในการเลือกใช้ Plug-in</p>
                </div>
                <div className='qa-question'>
                  <h5 className='text-2xl font-bold'>05. ต้องคอยอัปเกรดระบบและ Plug-in</h5>
                  <p>เพื่อรักษาความปลอดภัยและประสิทธิภาพ</p>
                </div>
              </div>
            </div>
            <div className='wordpress-experiences'>
              <h3 className='mb-16 text-4xl'>Experiences</h3>
              <div className=''>
                <ListBullet
                  list={[
                    'เว็บไซต์บริษัท (Company Website)',
                    'เว็บไซต์สินค้า (Brand Website)',
                    'เว็บไซต์ขาย (Sale Page)',
                    'เว็บไซต์โรงแรม (Hotel Website)',
                    'เว็บไซต์ร้านอาหาร (Restaurant Website)',
                    'เว็บไซต์ข่าวสาร (News Website)',
                    'เว็บไซต์บุคคล (Personal Blog)',
                    'เว็บไซต์ E-Commerce',
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-neutral py-28'>
        <div className='container mx-auto space-y-8 px-4'>
          <div className='grid grid-cols-1 items-center gap-4 text-white lg:grid-cols-2 xl:gap-8'>
            <ImgResponsive
              src='/images/service/service_contact.webp'
              alt='Twin Synergy service'
              sourceImgSm='/images/service/service_contact.webp'
              sourceImgMd='/images/service/service_contact.webp'
              loadingLazy
              className='mx-auto'
            />
            <div className='space-y-6'>
              <h2 className='xl:text-7xl'>
                ส่งรายละเอียด
                <br />
                ของเว็บไซต์ที่คุณ
                <br />
                ต้องการมาให้เรา
              </h2>
              <p className='font-bold xl:text-4xl'>เราสามารถประเมินราคาและให้คำแนะนำได้ทันที</p>
              <Button
                htmlType='button'
                className='btn-warning'
                onClick={() => Router.push('/contact')}
              >
                ส่งข้อมูลให้เรา
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className='pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='ผลงาน'
            colorPrologue='rgba(0,0,0,.08)'
            title={<>ผลงานของเรา</>}
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-2 lg:grid-cols-4'>
          <PortfolioItem
            title='Brandthink shop'
            categories='website'
            serviceImg='/images/service/sme/Brandthink_shop.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/brandthink-shop/'
          />
          <PortfolioItem
            title='The Cliff Lipe'
            categories='website'
            serviceImg='/images/service/sme/The_Cliff_Lipe.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/the-cliff-lipe/'
          />
          <PortfolioItem
            title={
              <>
                Tongna Cottage
                <br />
                Natural Resort
              </>
            }
            categories='website'
            serviceImg='/images/service/sme/Tongna_Cottage_Natural_Resort.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/'
          />
          <PortfolioItem
            title='Tiger'
            categories='website'
            serviceImg='/images/service/sme/Tiger.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/'
          />
        </div>
        <div className='bg-neutral text-center'>
          <Link
            className='flex items-center justify-center py-4 font-light text-white'
            href='/portfolio'
          >
            ดูโปรเจกต์ทั้งหมด <FaArrowRight className='ml-2' size={14} />
          </Link>
        </div>
        <div className='warranty grid grid-cols-2 lg:grid-cols-5'>
          <WarrantyItem
            content={
              <>
                Warrantee Source
                <br />
                code 1 year
              </>
            }
            serviceImg='/images/service/warratee.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Support team (8/7)
                <br />6 month
              </>
            }
            serviceImg='/images/service/support_team.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content='Free MA 6 month'
            serviceImg='/images/service/free_MA.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free consultant
                <br />
                Forever
              </>
            }
            serviceImg='/images/service/free_consultant.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free integration
                <br />
                service fee
              </>
            }
            serviceImg='/images/service/free_integration.webp'
            serviceBg='#F7F8F9'
          />
        </div>
      </div>
      <div className='bg-author-base py-24'>
        <div className='container mx-auto '>
          <ServiceGetInTouch content='เว็บไซต์คือปัจจัยสำคัญที่จะพาธุรกิจของคุณไปสู่ความสำเร็จ หากคุณกำลังตัดสินใจที่จะสร้างเว็บไซต์ดี ๆ ให้กับธุรกิจของคุณ อย่าเพิ่งนึกถึงใคร ให้นึกถึงเรา ติดต่อมาได้เลย รอนะ !!' />
        </div>
      </div>
      <div className='section-service pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='บริการ'
            colorPrologue='rgba(0,0,0,.08)'
            title='บริการอื่น ๆ'
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4'>
          <ServiceItem
            prologue='01'
            title='พัฒนาเว็บไซต์'
            serviceImg='/images/service/service-01.webp'
            serviceBg='#06B7B7'
            serviceUrl='website-development'
          />
          <ServiceItem
            prologue='02'
            title='พัฒนาแอปพลิเคชั่นมือถือ'
            serviceImg='/images/service/service-02.webp'
            serviceBg='#1990FF'
            serviceUrl='mobile-application-development'
          />
          <ServiceItem
            prologue='03'
            title='ออกแบบเว็บไซต์'
            serviceImg='/images/service/service-03.webp'
            serviceBg='#FFCA64'
            serviceUrl='website-design'
          />
          <ServiceItem
            prologue='04'
            title='เว็บไซต์สำหรับธุรกิจ SME'
            serviceImg='/images/service/service-04.webp'
            serviceBg='#FFAC79'
            serviceUrl='sme-website-development'
          />
          <ServiceItem
            prologue='05'
            title='ออกแบบและพัฒนา Line OA'
            serviceImg='/images/service/service-05.webp'
            serviceBg='#00BE00'
            serviceUrl='line-oa-development'
          />
          <ServiceItem
            prologue='06'
            title='พัฒนาซอฟต์แวร์ตามกำหนด'
            serviceImg='/images/service/service-06.webp'
            serviceBg='#FF7D7D'
            serviceUrl='custom-software-development'
          />
          <ServiceItem
            prologue='07'
            title='เพิ่มความปลอดภัย'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#B577E5'
            noLink
          />
          <ServiceItem
            prologue='08'
            title='ดูแลบำรุงรักษาเว็บไซต์'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#484848'
            noLink
          />
        </div>
      </div>
    </LayoutDefault>
  )
}

export default ServicePage
